import React, { useCallback, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import Spinner from '@prisjakt/ui-spinner';
import { Variant } from '@prisjakt/ui-button/src/types';

import feedbackActions from './actions';
import { Position } from './types';

import * as S from './styles';

type OwnProps = {
  children: React.ReactNode;
  className?: string;
  position?: Position;
  title?: string;
  variant?: Variant;
};

type DispatchProps = {
  startChat: () => void;
  open: () => void;
};

type Props = OwnProps & DispatchProps;

const FeedbackButton = ({
  className,
  children,
  open,
  startChat,
  position = 'inline',
  title,
  variant,
}: Props) => {
  const {
    market: { lazyLoadIntercom },
  } = useContext(AppContext);

  const [loadState, setLoadState] = useState('init');

  const load = useCallback(() => {
    // If intercom lazy load is disabled, simply open
    // the standard form
    if (!lazyLoadIntercom) {
      open();
      return;
    }

    window.onIntercomLoadedCb = (successful: boolean) => {
      if (!successful) {
        open();
        setLoadState('failed');
      } else {
        setLoadState('loaded');
      }

      window.onIntercomLoadedCb = undefined;
    };

    if (loadState === 'failed') {
      open();
    } else {
      if (loadState === 'init') {
        setLoadState('loading');
      }
      startChat();
    }
  }, [lazyLoadIntercom, loadState, open, startChat]);

  return (
    <>
      <S.FeedbackButton
        className={className}
        color="primary"
        position={position}
        onClick={load}
        data-test="FeedbackButton"
        title={title}
        variant={variant}
      >
        <Spinner isActive={loadState === 'loading'} />
        {children}
      </S.FeedbackButton>
    </>
  );
};

const dispatchProps = {
  open: feedbackActions.open,
  startChat: feedbackActions.startChat,
};

export default connect(null, dispatchProps)(FeedbackButton);
